// yyyy-MM-ddTHH:mm:ss.SX
//   yyyy year 4 digits
//   MM   month 2 digits
//   dd   day 2 digits
//   HH   hour 2 digits
//   mm   minutes 2 digits
//   ss   seconds 2 digits, optional
//   S    fraction of seconds up to 9 digits, optional
//   X    offset to UTC, optional. Either Z or +00:00 (+ or -, 4 digits, colon optional)
const ISO_DATETIME_REGEX = /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d(:\d\d(\.\d{1,9})?)?(Z|[+-]\d\d:?\d\d)?$/;

const padleft = (v: number, n: number): string => ('0000' + v).slice(-n);

/**
 * Wandelt einen String im vollen ISO Format (yyyy-MM-ddTHH:mm:ss.SX; Datum und Zeit; Sekunden und Zeitzoneninformation optional) in ein Date Objekt um.
 * @param value String im ISO Format
 * @return Date Objekt oder null, wenn value nicht dem ISO Format entspricht oder keinem gültigen Datum entspricht
 */
export function parseDate(value: string | null | undefined): Date | null {
    if (!value || !value.match(ISO_DATETIME_REGEX)) {
        return null;
    }

    const d = new Date(value);

    if (isNaN(d.getTime())) {
        return null;
    }
    return d;
}

/**
 * Wandelt ein Date Objekt in einen String im vollen ISO Format mit Datum und Zeit nach lokaler Zeitzone mit Zeitzonenoffset-Information um.
 * @param value Date Objekt
 * @return String im ISO Format oder null wenn value kein gültiges Datum ist
 */
export function stringifyDate(value?: Date | null): string | null {
    if (!value || isNaN(value.getTime())) {
        return null;
    }
    const yyyy = padleft(value.getFullYear(), 4);
    const MM = padleft(value.getMonth() + 1, 2);
    const dd = padleft(value.getDate(), 2);
    const HH = padleft(value.getHours(), 2);
    const mm = padleft(value.getMinutes(), 2);
    const ss = padleft(value.getSeconds(), 2);
    const S = padleft(value.getMilliseconds(), 3);
    const X_totalMinutes = Math.abs(value.getTimezoneOffset());
    const X_sign = value.getTimezoneOffset() > 0 ? '-' : '+';
    const X_hours = padleft(Math.floor(X_totalMinutes / 60), 2);
    const X_minutes = padleft(Math.floor(X_totalMinutes) % 60, 2);
    const X_seconds = padleft(Math.round((X_totalMinutes % 1) * 60), 2);
    const dateString = `${yyyy}-${MM}-${dd}T${HH}:${mm}:${ss}.${S}${X_sign}${X_hours}:${X_minutes}`;
    if (X_seconds !== '00') {
        return `${dateString}:${X_seconds}`;
    }
    return dateString;
}
